import { useContext } from "react";
import { ControlLayoutContext } from "@plansoft-configuration-renderer/layout";
import { defaultAttributeDisplayOptions, } from "../Attributes/AttributeDisplayOptions";
/**
 * Get attribute display options from context
 * - allows additional specifying default properties
 * @param defaultProps
 * @returns
 */
export function useAttributeDisplayOptions(defaultProps = {}) {
    const controlProps = useContext(ControlLayoutContext);
    // merge actual data with defaults
    return Object.assign(Object.assign(Object.assign({}, defaultAttributeDisplayOptions), defaultProps), controlProps);
}
export { useAttributeDisplayOptions as useAttributeLayout };
//# sourceMappingURL=AttributeLayoutContext.js.map